var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItaly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "italy",
    clipPath: "url(#clip0_1730_8000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.75 16.7778C31.75 25.4763 24.6985 32.5278 16 32.5278C7.30151 32.5278 0.25 25.4763 0.25 16.7778C0.25 8.07935 7.30151 1.02783 16 1.02783C24.6985 1.02783 31.75 8.07935 31.75 16.7778Z",
    fill: "#F0F0F0",
    stroke: "#ABABAB",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.0002 16.7779C32.0002 9.89845 27.6582 4.03376 21.5654 1.77307V31.7828C27.6582 29.522 32.0002 23.6573 32.0002 16.7779Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0 16.7779C0 23.6573 4.342 29.522 10.4348 31.7827V1.77307C4.342 4.03376 0 9.89845 0 16.7779Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1730_8000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.777832)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItaly);
export default __webpack_public_path__ + "static/media/italy.4fd6202c3a7a356dc94af44af564ab47.svg";
export { ForwardRef as ReactComponent };